import { Location, NavigateFunction } from 'react-router-dom';

type history = {
  navigate: null | NavigateFunction;
  location: null | Location<any>;
};

export const history: history = {
  navigate: null,
  location: null,
};
